import { Route, Routes } from "react-router-dom"
import Homepage from "../pages/Homepage"
import ThankyouPage from "../pages/ThankyouPage"
import TandCpage from "../pages/TandCpage"
export default function AllRoutes() {


    return <Routes>
        {/* <Route path="" element={<Homepage />}></Route> */}
        <Route path="/" element={<ThankyouPage />}></Route>
        <Route path="/t-and-c" element={<TandCpage />}></Route>
    </Routes>
}